import api from './api';
import { PopularNewsSite, ApiResponse } from '../types';

const popularNewsSitesService = {
  getPopularNewsSites: async (language: string): Promise<PopularNewsSite[]> => {
    try {
      const response = await api.get<ApiResponse<PopularNewsSite[]>>(`/popular-news-sites/language/${language}`);
      return response.data.results;
    } catch (error) {
      throw error;
    }
  },

  getAllPopularNewsSites: async (): Promise<Record<string, PopularNewsSite[]>> => {
    try {
      const response = await api.get<ApiResponse<Record<string, PopularNewsSite[]>>>('/popular-news-sites');
      return response.data.results;
    } catch (error) {
      throw error;
    }
  }
};

export default popularNewsSitesService; 